import { attr, belongsTo, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import DeliveryAddress from './DeliveryAddress';
import MealPreferences from './MealPreferences';
import ContactPreferences from './ContactPreferences';
import Event from './Event';
import ExperimentGroup from './ExperimentGroup';

const Customer = ApplicationRecord.extend({
  attrs: {
    first_name: attr(),
    last_name: attr(),
    email: attr(),
    personalisation_survey_state: attr(),
    created_at: attr({ persist: false }),
    default_delivery_address: belongsTo({ type: DeliveryAddress }),
    contact_preferences: belongsTo({ type: ContactPreferences }),
    events: hasMany({ type: Event }),
    experiment_groups: hasMany({ type: ExperimentGroup }),
    meal_preferences: belongsTo({ type: MealPreferences }),
  },
  static: {
    endpoint: '/customers',
    jsonapiType: 'customers-customers',
  },
  methods: {
    inExperimentGroup(experiment) {
      if (this.experiment_groups.length > 0) {
        const testGroup = this.experiment_groups.find(({ name }) => name.startsWith(experiment));

        return typeof testGroup !== 'undefined';
      }
      return false;
    },
  },
});

export default Customer;
